import React from 'react';
import styles from './RecordEditorDrawer.module.scss';
import Spinner from '../Spinner/Spinner';
export default function () {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.loadingContainer
  }, /*#__PURE__*/React.createElement(Spinner, {
    size: 32
  }));
}